<template>
  <div ref="container">
    <div class="title" @click="isTuoMin = !isTuoMin">基础用法(点击可切换是否对姓名手机号身份证脱敏)</div>
    <div class="info-box flex-c-s flex-wrap">
      <div class="row flex-c-s">
        <div class="field flex-shrink">姓名：</div>
        <div class="value flex-grow">{{ personUserInfo1.name | desensitization(isTuoMin ? {maskType: "name"} : {maskType: "none"})}}</div>
      </div>
      <div class="row flex-c-s">
        <div class="field flex-shrink">身份证号：</div>
        <div class="value flex-grow">{{ personUserInfo1.idCard | desensitization(isTuoMin ? {maskType: "idCard"} : {maskType: "none"})}}</div>
      </div>
      <div class="row flex-c-s">
        <div class="field flex-shrink">电话：</div>
        <div class="value flex-grow">{{ personUserInfo1.phone | desensitization(isTuoMin ? {maskType: "mobile"} : {maskType: "none"})}}</div>
      </div>
      <div class="row flex-c-s">
        <div class="field flex-shrink">出生日期：</div>
        <div class="value flex-grow">{{ personUserInfo1.birthday | formatDate("date")}}</div>
      </div>
      <div class="row flex-c-s">
        <div class="field flex-shrink">家庭地址：</div>
        <div class="value flex-grow">{{ personUserInfo1.address | desensitization(isTuoMin ? {maskType: "address"} : {maskType: "none"})}}</div>
      </div>
    </div>

    <div class="title">配置默认值</div>
    <div class="info-box flex-c-s flex-wrap">
      <div class="row flex-c-s">
        <div class="field flex-shrink">姓名：</div>
        <div class="value flex-grow">{{ personUserInfo2.name | desensitization({maskType: "name", defaultVal: "--"})}}</div>
      </div>
      <div class="row flex-c-s">
        <div class="field flex-shrink">身份证号：</div>
        <div class="value flex-grow">{{ personUserInfo2.idCard | desensitization({maskType: "idCard", defaultVal: "--"})}}</div>
      </div>
      <div class="row flex-c-s">
        <div class="field flex-shrink">电话：</div>
        <div class="value flex-grow">{{ personUserInfo2.phone | desensitization({maskType: "mobile", defaultVal: "--"})}}</div>
      </div>
      <div class="row flex-c-s">
        <div class="field flex-shrink">出生日期：</div>
        <div class="value flex-grow">{{ personUserInfo2.birthday | formatDate("date", "--")}}</div>
      </div>
      <div class="row flex-c-s">
        <div class="field flex-shrink">家庭地址：</div>
        <div class="value flex-grow">{{ personUserInfo2.address | desensitization({maskType: "address", defaultVal: "--"})}}</div>
      </div>
    </div>

    <div class="title">日期过滤器</div>
    <div class="info-box flex-c-s flex-wrap">
      <div class="row flex-c-s">
        <div class="field flex-shrink">date：</div>
        <div class="value flex-grow">{{ personUserInfo3.day | formatDate("date")}}</div>
      </div>
      <div class="row flex-c-s">
        <div class="field flex-shrink">month：</div>
        <div class="value flex-grow">{{ personUserInfo3.day | formatDate("month")}}</div>
      </div>
      <div class="row flex-c-s">
        <div class="field flex-shrink">datetime：</div>
        <div class="value flex-grow">{{ personUserInfo3.day | formatDate("datetime")}}</div>
      </div>
      <div class="row flex-c-s">
        <div class="field flex-shrink">time：</div>
        <div class="value flex-grow">{{ personUserInfo3.day | formatDate("time")}}</div>
      </div>
      <div class="row flex-c-s">
        <div class="field flex-shrink">year：</div>
        <div class="value flex-grow">{{ personUserInfo3.day | formatDate("year")}}</div>
      </div>
      <div class="row flex-c-s">
        <div class="field flex-shrink">year/month/day：</div>
        <div class="value flex-grow">{{ personUserInfo3.day | formatDate("yyyy/MM/dd")}}</div>
      </div>
    </div>

    <div class="title">脱敏过滤器</div>
    <div class="dict-normal">
      <div class="info-box flex-c-s flex-wrap">
        <div class="row flex-c-s">
          <div class="field flex-shrink">前一后一：</div>
          <div class="value flex-grow">{{ personUserInfo4.name | desensitization({start: 1, end: 1, defaultVal: "--"})}}</div>
        </div>
        <div class="row flex-c-s">
          <div class="field flex-shrink">前三后四：</div>
          <div class="value flex-grow">{{ personUserInfo4.phone | desensitization({start: 3, end: 4, defaultVal: "--"})}}</div>
        </div>
        <div class="row all flex-c-s">
          <div class="field flex-shrink">前三后四（中间6个*）：</div>
          <div class="value flex-grow">{{ personUserInfo4.address | desensitization({start: 3, end: 4, middle: 6, symbol: "#", defaultVal: "--"})}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "filters-other",
  data() {
    return {
      isTuoMin: true,
      personUserInfo1: {
        name: "沈小布",
        phone: "123456789001",
        birthday: "1995-01-05",
        address: "宁夏回族自治区闽宁镇金滩村涌泉社区520号",
        idCard: "350624199501051314"
      },
      personUserInfo2: {},
      personUserInfo3: {
        day: "2023-01-23"
      },
      personUserInfo4: {
        name: "沈小布",
        phone: "123456789001",
        birthday: "1993-03-21",
        address: "宁夏回族自治区闽宁镇金滩村涌泉社区520号"
      }
    }
  },
  created() {
    setTimeout(() => {
      this.personUserInfo2 = {
        name: "沈小布",
        phone: "123456789001",
        birthday: "",
        address: "宁夏回族自治区闽宁镇金滩村涌泉社区520号",
        idCard: "350624199501051314"
      }
    }, 2000)
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        const container = this.$refs.container
        const data = { "demoContainerHeight": container.scrollHeight + 20 }
        window.parent.postMessage(data, "*")
      }, 1000)
    })
  }
}
</script>

<style lang="less" scoped>
.flex-wrap {
  flex-wrap: wrap;
}
.flex-c-s {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.info-box {
  padding: 0 20px;
  .row {
    width: 50%;
    margin-top: 32px;
    .field {
      width: 144px;
      font-size: 16px;
      color: #666666;
      line-height: 18px;
    }
    .value {
      font-size: 16px;
      color: #333333;
      line-height: 18px;
    }
  }
}
</style>